import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-backdrop"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade", { 'ds-modal': _ctx.isDsModal, 'ds-modal--narrow': _ctx.isDsModalNarrow }]),
    role: "dialog",
    ref: "modalRef",
    "data-backdrop": _ctx.backdropStatic ? 'static' : null
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog", [
                _ctx.verticallyCentered ? 'modal-dialog-centered' : '',
                _ctx.isDsDialog ? 'ds-dialog' : '',
                _ctx.isDsDialogNarrow ? 'ds-dialog--narrow' : '',
            ]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.closeButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn-close",
              "data-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
            }, " Zavřít "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _renderSlot(_ctx.$slots, "afterBody")
      ])
    ], 2)
  ], 10, _hoisted_1))
}